import PhoneVerify from "./PhoneVerify";

export default PhoneVerify;
